// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  Flex,
  Paper,
  Title,
  Text,
  Box,
  Loader,
  Anchor,
  Image,
  Grid,
  List,
} from "@mantine/core";
import { FormattedMessage } from "react-intl";
import {
  useGetFetchPOAText,
  useSignPOA,
  useCreatePOA,
  useGetSignStatus,
  useCreateUser,
} from "../../../hooks/api";
import { useEffect, useState } from "react";
import { useUpdateCustomerPOAData } from "../../../hooks/ui/customerPOADataStore";

import QRCode from "react-qr-code";
import { usePOAStepsStore } from "../../../hooks/ui/poaStepsDataStore";
import { useMediaQuery } from "@mantine/hooks";
import FullmaktskollenImage from "/fullmaktskollen-logo.png";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";

export default function POABankID() {
  const { customerPOAData } = useUpdateCustomerPOAData();
  const { nextStep } = usePOAStepsStore();

  const [complete, setComplete] = useState(false);
  const createSign = useSignPOA();
  const createPOA = useCreatePOA();
  const createUser = useCreateUser();

  const poaOngoingFormatted =
    customerPOAData.validTo === null
      ? "Tillsvidare"
      : new Date(customerPOAData.validFrom).toISOString().split("T")[0];
  const isMobile = useMediaQuery("(max-width: 56.25em)");

  const htmlSignString = `
      <p>Jag skriver under informationsfullmakten</p>
      <p><b>Fullmaktshavare: 556974-8378, Sambla Group AB</b></p>
      <p><b>Fullmaktsgivare: ${customerPOAData.personalNumber}, ${customerPOAData.name} </b></p>
      <p><b>Giltighetstid: ${poaOngoingFormatted} ${customerPOAData.validTo ? " - " + new Date(customerPOAData.validTo).toISOString().split("T")[0] : ""}</b></p>
      `;

  const getSignStatus = useGetSignStatus({
    id: createSign.data?.body?.id,
    enabled: createSign.isSuccess && !complete,
    credentials: customerPOAData.credentials,
  });

  const { data } = useGetFetchPOAText({
    credentials: customerPOAData.credentials,
  });

  useEffect(() => {
    if (
      isMobile &&
      getSignStatus.data?.body?.providerInfo?.seBankID?.autoStartToken
    ) {
      window.location.assign(
        `bankid:///?autostarttoken=${getSignStatus.data?.body?.providerInfo?.seBankID?.autoStartToken}&redirect=null`
      );
    }
  }, [
    getSignStatus.data?.body?.providerInfo?.seBankID?.autoStartToken,
    isMobile,
  ]);

  const handleCreatePOA = () => {
    return new Promise((resolve, reject) => {
      createPOA.mutate(
        {
          credentials: customerPOAData.credentials,
          signedData: getSignStatus.data.body,
          email: customerPOAData.email,
          validFrom: customerPOAData.validFrom,
          validTo: customerPOAData.validTo,
        },
        {
          onSuccess: (data) => {
            resolve(data);
          },
          onError: (error) => {
            reject(new Error(error.message));
          },
        }
      );
    });
  };

  const handleCreateUser = () => {
    return new Promise((resolve, reject) => {
      createUser.mutate(
        {
          signedData: getSignStatus.data.body,
          email: customerPOAData.email,
          phone: customerPOAData.phoneNumber,
          credentials: customerPOAData.credentials,
        },
        {
          onSuccess: (data) => {
            resolve(data);
          },
          onError: (error) => {
            reject(new Error(error.message));
          },
        }
      );
    });
  };

  useEffect(() => {
    if (getSignStatus.data?.body?.status === "complete") {
      setComplete(true);
      handleCreateUser()
        .then((createdUser) => {
          if (createdUser) {
            return handleCreatePOA();
          } else {
            throw new Error("User creation failed.");
          }
        })
        .then((createdPOA) => {
          if (createdPOA) {
            console.log("POA created successfully:", createdPOA);
          }
        })
        .catch((error) => {
          console.error("Error during creation:", error);
        });
    }

    if (getSignStatus.data?.body?.status === "failed") {
      setComplete(true);
    }
  }, [getSignStatus.data]);

  useEffect(() => {
    createSign.mutate({
      ...customerPOAData,
      signText: htmlSignString + data.signText,
    });
  }, []);

  useEffect(() => {
    if (createPOA.isSuccess) {
      nextStep();
    }
  }, [createPOA.isSuccess, createPOA.isError]);

  return (
    <Flex justify="center" align="center" px={"xl"}>
      <Flex direction="column" maw={672} w={"100%"}>
        <Title
          order={2}
          mb="1rem"
          ff={"var(--wallet-font-family-subjecttivity)"}
        >
          <FormattedMessage
            id="bankID.title"
            defaultMessage="Please sign the power of attorney with BankID"
          />
        </Title>
        {createPOA?.error?.status === 409 ? (
          <Paper p={30} radius={"24px"} mb={"2rem"}>
            <Flex direction={"column"}>
              <Title
                order={5}
                mb={"1rem"}
                ff={"var(--wallet-font-family-subjecttivity)"}
              >
                Fullmakt har redan skapats
              </Title>
              <Text mb={"2rem"}>
                Vi har redan en fullmakt för dig. Om du har några frågor ring
                oss
              </Text>
            </Flex>
            <Grid>
              <Grid.Col span={{ base: 12, md: 6 }}>
                <Paper p={"lg"} withBorder radius={"24px"}>
                  <PhoneIcon
                    height="48px"
                    color={"var(--wallet-color-sambla-red-shade-600)"}
                  />

                  <Anchor
                    href="tel:0104248918"
                    display="block"
                    mb={"lg"}
                    mt={"lg"}
                  >
                    <strong>010 - 424 89 18</strong>
                  </Anchor>
                  <List listStyleType="none">
                    <List.Item>Mån 09-19</List.Item>
                    <List.Item>Tis - Tor 09-18</List.Item>
                    <List.Item>Fre 09-17</List.Item>
                    <List.Item>Lör - Sön 12-16</List.Item>
                  </List>
                </Paper>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6 }}>
                <Paper p={"lg"} withBorder radius={"24px"}>
                  <EnvelopeIcon
                    height="48px"
                    color={"var(--wallet-color-sambla-red-shade-600)"}
                  />

                  <Anchor
                    href="mailto:kundtjanst@samblapension.se"
                    display="block"
                    mb={"lg"}
                    mt={"lg"}
                  >
                    <strong>kundtjanst@samblapension.se</strong>
                  </Anchor>
                  <Text>Vi svarar så fort vi kan! </Text>
                  <Text>&nbsp;</Text>
                  <Text>&nbsp;</Text>
                </Paper>
              </Grid.Col>
            </Grid>
          </Paper>
        ) : (
          <>
            <Paper p={30} radius={"24px"} mb={"2rem"}>
              <Flex align="center">
                <Box pr={"4rem"}>
                  <Title
                    order={5}
                    mb={"1rem"}
                    ff={"var(--wallet-font-family-subjecttivity)"}
                  >
                    <FormattedMessage
                      id="bankID.card.title"
                      defaultMessage="Do the following :"
                    />
                  </Title>
                  <Text mb={"2rem"}>
                    <FormattedMessage
                      id="bankID.card.paragraph"
                      defaultMessage="Start the BankID app on your mobile unit and press 'Scan QR code'. Use the camera to scan the QR code and sign."
                    />
                  </Text>
                </Box>
                <Box>
                  {getSignStatus.isLoading ||
                    (createSign.isPending && <Loader />)}
                  {getSignStatus.isSuccess && !isMobile && (
                    <QRCode
                      value={
                        getSignStatus.data.body.providerInfo.seBankID.qrData
                      }
                    />
                  )}
                  {getSignStatus.isError && <>error</>}
                </Box>
              </Flex>
              {getSignStatus.isLoading ||
                (createSign.isPending && <Loader type="dots" />)}
              {getSignStatus.isSuccess && (
                <Text ta="center" mt={"xl"}>
                  Har du inte Mobil BankID?{" "}
                  <Anchor
                    href={`bankid:///?autostarttoken=${getSignStatus.data?.body?.providerInfo?.seBankID?.autoStartToken}&redirect=null`}
                  >
                    Använd BankID på samma enhet
                  </Anchor>
                </Text>
              )}
            </Paper>
            <Paper p={"lg"} radius={"24px"} mb={"xl"}>
              <Flex justify={"center"}>
                <Image
                  src={FullmaktskollenImage}
                  alt="Fullmaktskollen"
                  h={38}
                  w="auto"
                  fit="contain"
                />
              </Flex>
            </Paper>
          </>
        )}
      </Flex>
    </Flex>
  );
}
